export default __webpack_public_path__ + "static/media/green-streak-tree.e9982970.svg";